import { useCallback, useEffect, useState } from 'react';

type UseIdleModalParams = {
  enabled: boolean;
  idle: boolean;
  onQuit: () => void | Promise<void>;
};

export function useIdleModal({ enabled, idle, onQuit }: UseIdleModalParams) {
  const [idleModalOpen, setIdleModalOpen] = useState(false);
  const [hasBeenRedirectedByIdle, setHasBeenRedirectedByIdle] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    const shouldShowIdleModal = idle && !idleModalOpen && !hasBeenRedirectedByIdle;
    if (shouldShowIdleModal) {
      setIdleModalOpen(true);
      setHasBeenRedirectedByIdle(true);
    }
  }, [enabled, idle, idleModalOpen, hasBeenRedirectedByIdle]);

  useEffect(() => {
    if (!enabled) return;
    const shouldResetIdleRedirect = !idle && hasBeenRedirectedByIdle && !idleModalOpen;
    if (shouldResetIdleRedirect) {
      setHasBeenRedirectedByIdle(false);
    }
  }, [enabled, idle, hasBeenRedirectedByIdle, idleModalOpen]);

  const handleIdleContinue = useCallback(() => {
    setIdleModalOpen(false);
    setHasBeenRedirectedByIdle(false);
  }, []);

  const handleIdleQuit = useCallback(async () => {
    setIdleModalOpen(false);
    await onQuit();
  }, [onQuit]);

  return {
    idleModalOpen,
    setIdleModalOpen,
    handleIdleContinue,
    handleIdleQuit,
  };
}
